import { __assign, __rest } from "tslib";
import * as React from 'react';
import { default as MuiDialog } from '@material-ui/core/Dialog';
import { DialogTitle } from '../DialogTitle';
import { useStyles } from './Dialog.styles';
var DialogFocus = function (props) {
    var children = props.children, hasTitle = props.hasTitle, open = props.open;
    // Simple ref to search for children by classname
    var ref = React.useRef(null);
    // We want to force focus to either title or the dialog's contents. Material-UI does not seem to do that out of the box
    React.useLayoutEffect(function () {
        var _a, _b;
        var elementToFocus = hasTitle ? 'bb-h1-element' : 'bb-dialog-content';
        var elements = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getElementsByClassName(elementToFocus);
        // Fall back to focusing content if no title elements are found
        if (hasTitle && !(elements === null || elements === void 0 ? void 0 : elements.length)) {
            elements = (_b = ref.current) === null || _b === void 0 ? void 0 : _b.getElementsByClassName('bb-dialog-content');
        }
        if (open && (elements === null || elements === void 0 ? void 0 : elements.length)) {
            elements[0].focus();
        }
    }, [hasTitle, open]);
    return React.createElement("div", { ref: ref }, children);
};
export var Dialog = React.forwardRef(function (props, ref) {
    var baseClasses = useStyles(props);
    var children = props.children, hasTitle = props.hasTitle, isAlert = props.isAlert, open = props.open, classes = props.classes, other = __rest(props, ["children", "hasTitle", "isAlert", "open", "classes"]);
    var renderChildren = function () {
        return React.Children.map(children, function (child) {
            if (React.isValidElement(child)) {
                var elementChild = child;
                if (elementChild.type === DialogTitle) {
                    return React.cloneElement(elementChild, {
                        isAlert: isAlert,
                    });
                }
                return elementChild;
            }
            return child;
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(MuiDialog, __assign({ maxWidth: "md", scroll: "body", PaperProps: {
                elevation: 0,
                role: isAlert ? 'alertdialog' : 'dialog',
            }, TransitionProps: {
                role: undefined,
            }, open: open, ref: ref, classes: baseClasses }, other),
            React.createElement(DialogFocus, { open: open, hasTitle: hasTitle }, renderChildren()))));
});
DialogFocus.defaultProps = {
    hasTitle: true,
};
export default Dialog;
//# sourceMappingURL=Dialog.js.map